import { DECK_SIZE } from './cards';
import { nextInt } from './rng';
/** The 52-card deck in CardIndex order (0..51). Frozen; shuffle returns a fresh copy. */
export const FULL_DECK = Object.freeze(Array.from({ length: DECK_SIZE }, (_, i) => i));
/** Fisher–Yates shuffle driven by the injected Rng. Returns a NEW array; inputs are untouched. */
export const shuffle = (rng, cards = FULL_DECK) => {
    const out = cards.slice();
    for (let i = out.length - 1; i > 0; i--) {
        const j = nextInt(rng, i + 1);
        const tmp = out[i];
        out[i] = out[j];
        out[j] = tmp;
    }
    return out;
};
/**
 * Create a dealer over a freshly shuffled deck, excluding any `dead` cards (board + known holes).
 * The shuffle is fully determined by `rng`, so the same (seed-derived rng, dead) deals identically.
 */
export const createDealer = (rng, dead = []) => {
    const deadSet = new Set(dead);
    const stack = shuffle(rng, FULL_DECK.filter((c) => !deadSet.has(c)));
    let cursor = 0;
    const deal = (n = 1) => {
        if (cursor + n > stack.length) {
            throw new RangeError(`Deck exhausted: requested ${n}, only ${stack.length - cursor} left`);
        }
        const out = stack.slice(cursor, cursor + n);
        cursor += n;
        return out;
    };
    return {
        deal,
        dealOne: () => deal(1)[0],
        remaining: () => stack.length - cursor,
    };
};
//# sourceMappingURL=deck.js.map